import { render, staticRenderFns } from "./DisplayEvidence.vue?vue&type=template&id=636c3952&scoped=true&"
import script from "./DisplayEvidence.vue?vue&type=script&lang=js&"
export * from "./DisplayEvidence.vue?vue&type=script&lang=js&"
import style0 from "./DisplayEvidence.vue?vue&type=style&index=0&id=636c3952&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636c3952",
  null
  
)

export default component.exports